import { Body, Box, ExpandableCard, H4 } from '../widgets'
import { SubscriptionFeatures } from './'

export const SubscriptionOption = ({ selected, subscription: { teams, price, type }, ...props }) => {

  const content = () => (
    <Box column alignItems="start" gap={16}>
      <Box column gap={8}>
        <H4 bold>{teams}</H4>
      </Box>
      <Box>
        <H4 bold p={0} align="right">${price} <Body size={12} style={{ marginLeft: -4 }}>USD p/a</Body></H4>
      </Box>
    </Box>
  )

  const expandedContent = () => (
    <SubscriptionFeatures subscriptionType={type} />
  )

  return <ExpandableCard
    selected={selected}
    content={content()}
    expandedContent={expandedContent()}
    {...props}
  />
}